import React, { useState } from "react";
import { FaBoxOpen, FaTags, FaImage, FaCogs, FaShoppingCart, FaHistory, FaSignOutAlt } from "react-icons/fa";
import AddProductModal from "./AddProductModal";
import AddCategoryModal from "./AddCategoryModal";
import AdminProductList from "./AdminProductList";
import AdminCategoryList from "./AdminCategoryList";
import { db } from "../firebase";
import { collection, onSnapshot, doc, deleteDoc, getDocs } from "firebase/firestore";
import EditBannerModal from "./EditBannerModal";
import AdminGalleryManager from './AdminGalleryManager';
import ContentTabs from './ContentTabs';


const SECTIONS = [
  { key: "productos", label: "Productos", icon: <FaBoxOpen /> },
  { key: "categorias", label: "Categorías", icon: <FaTags /> },
  { key: "contenido", label: "Contenido", icon: <FaImage /> },
  { key: "pedidos", label: "Pedidos", icon: <FaShoppingCart /> },
  { key: "config", label: "Configuración", icon: <FaCogs /> },
];

const AdminDashboard = ({
  onLogout,
  bannerVideos,
  setBannerVideos,
  bannerText,
  setBannerText,
}) => {
  const [section, setSection] = useState("productos");
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isAddCategoryModalOpen, setIsAddCategoryModalOpen] = useState(false);
  const [productToEdit, setProductToEdit] = useState(null);
  const [categoryToEdit, setCategoryToEdit] = useState(null);
const [categoryProducts, setCategoryProducts] = useState([]);
const [showProductsModal, setShowProductsModal] = useState(false);
const [currentCategory, setCurrentCategory] = useState("");
const [isBannerModalOpen, setBannerModalOpen] = useState(false);

const handleViewProducts = (catName) => {
  // Aquí consultamos productos desde Firestore (puedes hacerlo así para que siempre esté actualizado):
  async function fetchCategoryProducts() {
    const querySnapshot = await getDocs(collection(db, "productos"));
    const allProducts = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    const filtered = allProducts.filter(prod => prod.category === catName);
    setCategoryProducts(filtered);
    setCurrentCategory(catName);
    setShowProductsModal(true);
  }
  fetchCategoryProducts();
};

  const renderSection = () => {
    switch (section) {
      case "productos":
        return (
          <div>
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-2xl font-bold">Productos</h2>
              <button
                className="bg-blue-600 text-white px-4 py-2 rounded-xl font-semibold hover:bg-blue-700 transition-all"
                onClick={() => {
                  setProductToEdit(null);
                  setIsAddModalOpen(true);
                }}
              >
                + Añadir Producto
              </button>
            </div>
            <AdminProductList onEdit={(prod) => { setProductToEdit(prod); setIsAddModalOpen(true); }} />
          </div>
        );
      case "categorias":
        return (
          <div>
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-2xl font-bold">Categorías</h2>
              <button
                className="bg-green-600 text-white px-4 py-2 rounded-xl font-semibold hover:bg-green-700 transition-all"
                onClick={() => {
                  setCategoryToEdit(null); // << IMPORTANTE: limpiar edición
                  setIsAddCategoryModalOpen(true);
                }}
              >
                + Añadir Categoría
              </button>
            </div>
<AdminCategoryList
  onEdit={(cat) => { setCategoryToEdit(cat); setIsAddCategoryModalOpen(true); }}
  onViewProducts={handleViewProducts}
/>
          </div>
        );
case "contenido":
  return (
    <div className="w-full flex flex-col items-center mt-10">
      <h2 className="text-3xl font-bold text-blue-900 mb-10 text-center w-full">Gestión de Contenido</h2>
      <div className="bg-white shadow-xl rounded-2xl max-w-2xl w-full p-0">
        <ContentTabs 
          bannerVideos={bannerVideos}
          setBannerVideos={setBannerVideos}
          bannerText={bannerText}
          setBannerText={setBannerText}
        />
      </div>
    </div>
  );
  
      case "pedidos":
        return (
          <div>
            <h2 className="text-2xl font-bold mb-6">Gestión de Pedidos</h2>
            <button className="bg-purple-600 text-white px-4 py-2 rounded-xl font-semibold mb-3">
              Ver Pedidos
            </button>
            <button className="bg-purple-400 text-white px-4 py-2 rounded-xl font-semibold">
              Historial de Ventas
            </button>
          </div>
        );
      case "config":
        return (
          <div>
            <h2 className="text-2xl font-bold mb-6">Configuración</h2>
            <button className="bg-gray-600 text-white px-4 py-2 rounded-xl font-semibold mb-3">
              Opciones avanzadas
            </button>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="flex min-h-screen bg-gradient-to-tr from-[#E0F7FA] via-[#F8FAFC] to-[#B6E5FF]">
      {/* Sidebar */}
      <div className="w-60 bg-white border-r border-gray-100 py-10 px-4 flex flex-col gap-8 shadow-xl min-h-screen">
        <h1 className="text-3xl font-extrabold text-blue-700 mb-12 text-center">Atlantis Admin</h1>
        {SECTIONS.map((sec) => (
          <button
            key={sec.key}
            onClick={() => setSection(sec.key)}
            className={`flex items-center gap-3 px-4 py-3 rounded-xl text-lg font-semibold mb-2 transition-all ${
              section === sec.key
                ? "bg-blue-100 text-blue-800 shadow"
                : "text-gray-600 hover:bg-blue-50"
            }`}
          >
            <span className="text-2xl">{sec.icon}</span>
            {sec.label}
          </button>
        ))}
        <button
          onClick={onLogout}
          className="mt-auto bg-red-500 text-white py-3 px-4 rounded-xl font-semibold hover:bg-red-600 transition-colors flex items-center gap-3 justify-center"
        >
          <FaSignOutAlt /> Cerrar Sesión
        </button>
      </div>
      {/* Content */}
      <div className="flex-1 p-10">{renderSection()}</div>
      {/* Modals */}
      <AddProductModal
        isOpen={isAddModalOpen}
        onClose={() => { setIsAddModalOpen(false); setProductToEdit(null); }}
        productToEdit={productToEdit}
        onProductAdded={() => {}}
      />
      <AddCategoryModal
        isOpen={isAddCategoryModalOpen}
        onClose={() => { setIsAddCategoryModalOpen(false); setCategoryToEdit(null); }}
        onCategoryAdded={() => {}}
        categoryToEdit={categoryToEdit}
      />
      {showProductsModal && (
  <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50">
    <div className="bg-white rounded-xl shadow-2xl p-8 w-full max-w-2xl relative">
      <h2 className="text-2xl font-bold mb-4 text-center">
        Productos en "{currentCategory}"
      </h2>
      <button
        className="absolute top-2 right-2 text-lg bg-gray-200 px-3 py-1 rounded-full hover:bg-gray-300"
        onClick={() => setShowProductsModal(false)}
      >
        X
      </button>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {categoryProducts.length === 0 ? (
          <div className="col-span-2 text-gray-500 text-center italic">
            No hay productos en esta categoría.
          </div>
        ) : (
          categoryProducts.map((prod) => (
            <div key={prod.id} className="flex items-center gap-4 p-3 rounded-lg bg-blue-50">
              <img
                src={prod.image}
                alt={prod.name}
                className="w-14 h-14 object-cover rounded border"
              />
              <div>
                <div className="font-bold">{prod.name}</div>
                <div className="text-sm text-gray-500">${prod.price?.toLocaleString()}</div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  </div>
)}
{isBannerModalOpen && (
  <EditBannerModal
    videos={bannerVideos}
    onSaveVideos={setBannerVideos}
    text={bannerText}
    onSaveText={setBannerText}
    onClose={() => setBannerModalOpen(false)}
  />
)}

    </div>
  );
};

export default AdminDashboard;
